import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { TenantContextService } from '@core/tenant-context.service';

export const ensureNoPortalGuard: CanMatchFn = () => {
  const service = inject(TenantContextService);

  return service.getTenant() === null;
};
